
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/components/LanguageContext";
import { useNavigate } from "react-router-dom";
import { useLanguagePath } from "@/utils/language";
import { useTranslations } from "@/hooks/useTranslations";

export const SessionsActions = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const { getPath } = useLanguagePath();
  const { t } = useTranslations("training-sessions");

  const handleNavigation = () => {
    navigate(getPath("/dashboard/training-sessions/new"));
  };

  return (
    <Button 
      onClick={handleNavigation}
      className="bg-flame hover:bg-flame/90 text-white"
    >
      <Plus className="h-4 w-4 mr-2" />
      {t("button.add")}
    </Button>
  );
};
